import { render, staticRenderFns } from "./editFloorShare.vue?vue&type=template&id=a3cffd8a&scoped=true"
import script from "./editFloorShare.vue?vue&type=script&lang=js"
export * from "./editFloorShare.vue?vue&type=script&lang=js"
import style0 from "./editFloorShare.vue?vue&type=style&index=0&id=a3cffd8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cffd8a",
  null
  
)

export default component.exports